import React, { useState, useEffect } from 'react'
import './styles/NavBar.scss'
import BurgerButton from './BurgerButton'
import BurgerMenu from './BurgerMenu'
import { Link } from 'gatsby'
import Icons from './Icons'

const NavBar = props => {
  const [scrollState, setScrollState] = useState("no")
  let pathname = typeof window !== "undefined" ? window.location.pathname : ""
  let listener = null

  /**
   * Handle toggling the scroll class on navbar for scroll style after user starts to scroll.
   */
  useEffect(() => {
    listener = document.addEventListener("scroll", e => {
      var scrolled = document.scrollingElement.scrollTop
      if (scrolled >= 25) {
        if (scrollState !== "scrolled") {
          document.getElementById('navbar').classList.add('scroll')
          setScrollState("scrolled")
        }
      } else {
        if (scrollState !== "top") {
          document.getElementById('navbar').classList.remove('scroll')
          setScrollState("no")
        }
      }
    })
    return () => {
      document.removeEventListener("scroll", listener)
    }
  }, [scrollState])

  const navOptions = [
    {
      name: 'Menu',
      link: '/menu/food',
      sub_options: [
        {
          name: 'Food',
          link: '/menu/food'
        },
        {
          name: 'Drinks',
          link: '/menu/drinks'
        },
        {
          name: 'Delivery',
          link: '/menu/delivery'
        },
        // {
        //   name: "What's New",
        //   link: '/whats-on/new-menu-items/'
        // },
        {
          name: 'RSPCA Approved',
          link: '/about/rspca'
        }
      ]
    },
    {
      name: 'Book A Table',
      link: '/book',
      sub_options: []
    },
    {
      name: 'Locations',
      link: '/locations',
      sub_options: []
    },
    {
      name: "What's On",
      link: '/whats-on',
      sub_options: [
        {
          name: 'Events',
          link: '/whats-on/'
        },
        {
          name: 'Sports',
          link: '/whats-on/sports'
        }
      ]
    },
    {
      name: 'Functions',
      link: '/functions',
      sub_options: []
    },
    {
      name: 'Order Now',
      link: '/order',
      sub_options: []
    }
  ]

  /**
  * Creates the nav list item as either a normal link or dropdown links
  * @param {*} link 
  * @param {*} index 
  * @returns A Link element or dropdown element
  */
  const createNav = (link, index) => {
    if (link.sub_options.length !== 0) {
      return (
        <li key={index} className="dropdown nav-text">
          <Link title={link.name + ' | TGI Fridays'}  className='nav-text dropdown-header' to={link.link}>{link.name} <i className={`arrow up`}></i></Link>
          <ul className={`dropdown-menu`}>
            {link.sub_options.map((option, key) => {
              return <li className='nav-text' key={key}><Link title={option.name + ' | TGI Fridays'}  to={option.link}>{option.name}</Link></li>
            })}
          </ul>
        </li>
      )
    } else {
      return <li className='nav-text' key={index}><Link title={link.name + ' | TGI Fridays'}  to={link.link}>{link.name}</Link></li>
    }
  }

  const checkUrl = () => {
    const array = pathname.split('/')
    const results = array.filter(element => {
      return element !== '';
    });
    if (results.includes('food') || (results.includes('drinks') && results.length > 2) || (results.includes('locations') && results.length < 2) || (results.includes('whats-on') && results.length === 1)) {
      return 'hide-shadow'
    } 
    return ''
  }

  return (
    <nav id={'navbar'} className={`navbar ${scrollState} ${checkUrl()}`}>
      <BurgerButton />
      <div className="navbar-container">
        
        <div className="navbar__logo">
          <Link title='TGI Fridays Home' to='/'>
          <svg width="140" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 300 112"><defs></defs><polygon className="cls-1" points="36.84 80.3 49.33 80.3 49.33 62.32 67.8 62.32 67.8 51.56 49.33 51.56 49.33 42.95 69.88 42.95 69.88 31.7 36.84 31.7 36.84 80.3" /><path className="cls-1" d="M109.15,57.25a15.37,15.37,0,0,0,2.39-8.89V48a17.78,17.78,0,0,0-1.11-6.56,14,14,0,0,0-3.12-4.83q-4.8-4.92-14.58-4.93H73.64V80.3H86.07V65.23h4.44L98.77,80.3h14.09l-10-17.63A16.52,16.52,0,0,0,109.15,57.25ZM99,49a6.09,6.09,0,0,1-1.77,4.61,6.86,6.86,0,0,1-5,1.71H86.07V42.6h6.1a7.43,7.43,0,0,1,5,1.56A5.84,5.84,0,0,1,99,48.85Z" /><rect className="cls-1" x="115.93" y="31.7" width="12.5" height="48.6" /><path className="cls-1" d="M174.94,56.28v-.84a27.51,27.51,0,0,0-1.63-9.71,20.67,20.67,0,0,0-4.75-7.5,21.35,21.35,0,0,0-7.71-4.83,29.87,29.87,0,0,0-10.41-1.7h-16V80.3h15.76a29.72,29.72,0,0,0,10.52-1.74,21.46,21.46,0,0,0,7.77-4.89,20.68,20.68,0,0,0,4.79-7.6A28.17,28.17,0,0,0,174.94,56.28Zm-12.77.07q0,6.52-3.2,9.65a11.47,11.47,0,0,1-8.39,3.12H147V42.88h3.61A11.47,11.47,0,0,1,159,46q3.19,3.14,3.2,9.72Z" /><path className="cls-1" d="M189.6,31.42,172.52,80.3h12.84l2.78-8.75h15.27l2.85,8.75h13.12L202.23,31.42Zm1.66,30.13,4.52-14.23,4.51,14.23Z" /><polygon className="cls-1" points="239.76 31.7 231.56 49.27 223.44 31.7 209.63 31.7 225.25 62.11 225.25 80.3 237.74 80.3 237.74 61.97 253.36 31.7 239.76 31.7" /><path className="cls-1" d="M283,56.1A19.28,19.28,0,0,0,278.29,53,54.48,54.48,0,0,0,272,50.58c-1.53-.55-2.79-1.06-3.78-1.52a15.31,15.31,0,0,1-2.36-1.32,4.06,4.06,0,0,1-1.22-1.25,3,3,0,0,1-.35-1.46V45a2.79,2.79,0,0,1,1.15-2.29,5.23,5.23,0,0,1,3.3-.9,14.76,14.76,0,0,1,5.9,1.25,24.52,24.52,0,0,1,5.41,3.19l6.32-9.3a24.8,24.8,0,0,0-8.12-4.51A29.8,29.8,0,0,0,269.05,31a22,22,0,0,0-7.18,1.11,16.28,16.28,0,0,0-5.49,3.09,13.49,13.49,0,0,0-3.47,4.72A14.82,14.82,0,0,0,251.7,46v.21a13,13,0,0,0,1.14,5.69,12.3,12.3,0,0,0,3.23,4.1A21.41,21.41,0,0,0,261,59a67.5,67.5,0,0,0,6.32,2.46c1.43.51,2.61,1,3.54,1.39a12.41,12.41,0,0,1,2.19,1.22,3.62,3.62,0,0,1,1.11,1.21,3,3,0,0,1,.31,1.32v.07a3.06,3.06,0,0,1-1.29,2.57,6.16,6.16,0,0,1-3.78,1,16.43,16.43,0,0,1-6.87-1.52,29.52,29.52,0,0,1-6.32-4l-6.66,9.09a27.57,27.57,0,0,0,9.33,5.45A32.55,32.55,0,0,0,269.33,81a23.22,23.22,0,0,0,7.15-1,15.91,15.91,0,0,0,5.59-3,13.89,13.89,0,0,0,3.64-4.82A15,15,0,0,0,287,65.72v-.14a12.86,12.86,0,0,0-1-5.41A12.41,12.41,0,0,0,283,56.1Z" /><polygon className="cls-1" points="9.44 62.71 3.81 62.71 3.81 80.99 9.44 80.99 9.44 74.98 28.14 74.98 28.14 68.72 9.44 68.72 9.44 62.71" /><path className="cls-1" d="M13.93,41.89v9.74h4.83V47.77h3.61a5,5,0,0,1,.73,2.82c0,3.12-2.46,5.52-6.91,5.52h-.35c-4,0-6.74-2.36-6.74-5.46a6.8,6.8,0,0,1,2-4.76L6.35,42.42a12.5,12.5,0,0,0-3,8.37c0,6.71,5.08,11.72,12.38,11.72h.49c7.61,0,12.3-5,12.3-11.68a14.77,14.77,0,0,0-3-8.94Z" /><rect className="cls-1" x="3.81" y="31.7" width="24.33" height="6.26" /><polygon className="cls-1" points="288.42 76.72 290.02 76.72 290.02 80.99 290.66 80.99 290.66 76.72 292.27 76.72 292.27 76.18 288.42 76.18 288.42 76.72" /><polygon className="cls-1" points="296.73 76.18 295.21 80.22 293.69 76.18 292.81 76.18 292.81 80.99 293.42 80.99 293.42 76.99 293.43 76.99 294.94 80.99 295.48 80.99 296.99 76.99 297 76.99 297 80.99 297.61 80.99 297.61 76.18 296.73 76.18" /></svg>
          </Link>
        </div>
        
        <ul className="dropdowns-desktop">
          {navOptions.map((link, index) => createNav(link, index))}
          
        </ul>
        <div className="myfridays">
          <Link title='Rewards | TGI Fridays' to='/rewards/'><Icons name='myfridays' /></Link>
        </div>
      </div>

      <BurgerMenu />
    </nav>

  )
}

export default NavBar
